function Pagination({ currentPage, totalPages, onPageChange, totalItems, pageSize }) {
    const renderPaginationButtons = () => {
        const maxButtons = 5;
        let pages = [];

        if (totalPages <= maxButtons) {
            for (let i = 0; i < totalPages; i++) {
                pages.push(
                    <button
                        key={i}
                        onClick={() => onPageChange(i)}
                        className={`px-3 py-2 border ${currentPage === i ? 'bg-gray-200' : ''}`}
                    >
                        {i + 1}
                    </button>
                );
            }
        } else {
            if (currentPage > 2) {
                pages.push(
                    <button key={0} onClick={() => onPageChange(0)} className={`px-3 py-2 border ${currentPage === 0 ? 'bg-gray-200' : ''}`}>
                        1
                    </button>
                );
            }
            if (currentPage > 3) {
                pages.push(<span key="start-ellipsis" className="px-2">...</span>);
            }

            const start = Math.max(0, currentPage - 2);
            const end = Math.min(totalPages - 1, currentPage + 2);

            for (let i = start; i <= end; i++) {
                pages.push(
                    <button key={i} onClick={() => onPageChange(i)} className={`px-3 py-2 border ${currentPage === i ? 'bg-gray-200' : ''}`}>
                        {i + 1}
                    </button>
                );
            }

            if (currentPage < totalPages - 4) {
                pages.push(<span key="end-ellipsis" className="px-2">...</span>);
            }

            if (currentPage < totalPages - 3) {
                pages.push(
                    <button key={totalPages - 1} onClick={() => onPageChange(totalPages - 1)} className={`px-3 py-2 border ${currentPage === totalPages - 1 ? 'bg-gray-200' : ''}`}>
                        {totalPages}
                    </button>
                );
            }
        }

        return pages;
    };

    const startItem = totalItems === 0 ? 0 : currentPage * pageSize + 1;
    const endItem = Math.min(totalItems, (currentPage + 1) * pageSize);

    return (
        <div className="flex flex-col items-center gap-2">
            <div className="inline-flex items-center gap-1">
                <button
                    onClick={() => onPageChange(currentPage - 1)}
                    disabled={currentPage === 0}
                    className="px-3 py-2 border bg-white hover:bg-gray-100 disabled:opacity-50"
                >
                    {"<"}
                </button>

                {renderPaginationButtons()}

                <button
                    onClick={() => onPageChange(currentPage + 1)}
                    disabled={currentPage >= totalPages - 1}
                    className="px-3 py-2 border bg-white hover:bg-gray-100 disabled:opacity-50"
                >
                    {">"}
                </button>
            </div>

            <div className="text-sm text-gray-600 select-none">
                Mostrando {startItem}–{endItem} de {totalItems} resultados
            </div>
        </div>
    );
}

export default Pagination;
